<template>
    <el-dialog
            :title="title"
            :visible.sync="showDlg"
            :fullscreen=true
            :lock-scroll="false"
            :append-to-body="true"
            :close-on-click-modal="false"
            class="dlg-normal">

        <el-form :model="salInfoForm" :rules="rules" ref="salInfoForm" label-position="top">

            <el-tabs v-model="activeTabName" @tab-click="handleMainTabClick">
                <el-tab-pane label="客户经理信息" name="tab1">
                    <div>
                        <div class="tipTitle">基本信息</div>
                        <div class="form-s">
                            <el-row :gutter="30">
                                <el-col :span="c1">
                                    <el-form-item label="姓名" prop="name">
                                        <el-input size="small" v-model="salInfoForm.name" placeholder="姓名" :disabled="inOptType==='UPD' || inOptType==='VIEW'" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="电话" prop="phone">
                                        <el-input size="small" v-model="salInfoForm.phone" placeholder="手机号码" :disabled="inOptType==='UPD' || inOptType==='VIEW'" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="c1">
                                    <el-form-item label="登录账号" prop="userCode">
                                        <el-input size="small" v-model="salInfoForm.userCode" placeholder="登录账号，建议和手机号码相同" :disabled="inOptType==='UPD' || inOptType==='VIEW'" ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="height: 20px" />
                    </div>
                </el-tab-pane>
                <el-tab-pane label="产品和费率" name="tab2" :disabled="tab2Disable">
                    <div class="tipTitle">产品选择</div>
                    <div class="form-s">
                        <el-table :data="salInfoForm.userProductList" v-loading="loading" size="mini" border
                                  :header-cell-style="{background:'#fafafa'}"
                                  ref="prodTable">
                            <el-table-column v-if="inOptType!=='VIEW'" type="selection" width="55"/>
                            <el-table-column label="产品名称" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-tag type="warning" effect="dark" style="height: 25px">
                                        <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                                    </el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column label="费率信息" prop="payProductChannelList" align="center">
                                <template slot-scope="scope">
                                    <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false"
                                    >
                                        <el-table-column width="150" align="center"
                                                         label="交易方式">
                                            <template slot-scope="scope">
                                                {{scope.row.payName}}
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="费率" prop="userRateList" align="center">
                                            <template slot-scope="scope">
                                                <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                                    <el-table-column label="费率类型" prop="rateTypeDesc" />
                                                    <el-table-column label="费率（%）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.rate===null">--</span>
                                                            <el-input-number :disabled="inOptType==='VIEW' || inOptType!=='INS'" v-else :precision="2" :min="arch_miniRate[scope.row.id].rate" :controls="false" v-model="scope.row.rate" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔固定（元）" >
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.fixRate===null">--</span>
                                                            <el-input-number :disabled="inOptType==='VIEW'" v-else :precision="2" :min="arch_miniRate[scope.row.id].fixRate"  :controls="false" v-model="scope.row.fixRate" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔最低（元）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.feeLowest===null">--</span>
                                                            <el-input-number :disabled="inOptType==='VIEW'" v-else :precision="2"  :min=arch_miniRate[scope.row.id].feeLowest :controls="false" v-model="scope.row.feeLowest" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="单笔封顶（元）">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.feeHighest===null">--</span>
                                                            <el-input-number :disabled="inOptType==='VIEW'" v-else :precision="2" :min="arch_miniRate[scope.row.id].feeHighest" :controls="false" v-model="scope.row.feeHighest" :key="scope.row.id" />
                                                        </template>
                                                    </el-table-column>

                                                </el-table>
                                            </template>
                                        </el-table-column>
                                    </el-table>

                                    <div class="tipTitle" style="display: flex; justify-content: left;">
                                        <!--
                                        <span style="font-weight:bold;font-size: 12px; color: red;">到账周期：{{scope.row.payProduct.settleCycle===1?'D0':'D1'}}</span>
                                        -->
                                        <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{_enums.ProductChannelEnum.getDescById(scope.row.payProduct.productCode)}}</span>
                                    </div>


                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button v-if="inOptType!=='VIEW'" size="small" @click="showDlg = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleMainDlgOkClick">{{inOptType==='VIEW'?'关 闭':'确 定'}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {deepClone, findIdxByKeyValue} from "../../utils/datatool";
    import {URL_DATA_USER_BASE_PRORATE, URL_DATA_USER_BASE_PRORATE_BY_USER} from "../../utils/cons";
    import {MiniRate} from "../../utils/MiniRate";
    export default {
        name: "SalBaseDlg",
        props:["inOptType", "inSalInfo"],
        components: {
        },
        data() {
            return {
                isEditTermRate: false,
                ysfTermRateArray: [],
                arch_userBaseProductRateInfo: [],
                myTermRate: [],
                arch_miniRate: null,
                activeTabName: 'tab1',
                loading: false,
                slChecked: false,
                jhChecked: false,
                title: null,
                tab2Disable: true,
                showDlg: false,
                c0: 3,
                c1: 6,
                c2: 12,
                c3: 18,
                c4: 24,
                salInfoForm: {
                    ysfTermRateArray:[],
                    id: null,
                    userCode: null,
                    name: null,
                    phone: null,
                    agentId: null,
                    sysLoginInfo: null,
                    userProductList: []
                },
                rules: {
                    'name': [{required: true, message: '请输入主账号名称', trigger: 'blur'}],
                    'phone': [{required: true, message: '请输入手机号', trigger: 'blur'}],
                    'userCode': [{required: true, message: '请输入登录账号', trigger: 'blur'}],
                }
            };
        },
        //////////////////////////////////////////////////////////////////////
        // 组件初始化加载
        //////////////////////////////////////////////////////////////////////
        mounted() {
            switch (this.inOptType) {
                case 'INS':
                    this.title = '新增客户经理';
                    // 用户基础产品费率档案
                    this.getRequest(URL_DATA_USER_BASE_PRORATE).then(resp => { if (resp) this.arch_userBaseProductRateInfo = resp.data; this.tab2Disable = false;});
                    this.arch_miniRate = this.$root.g_data_mini_rate; // 新进件的费率ID为成本费率的ID
                    break;
                case 'VIEW':
                case 'UPD':
                    this.title = '修改客户经理';
                    this.tab2Disable = false;

                    this.arch_miniRate = new MiniRate();
                    for(let iii=0; iii<this.inSalInfo.userProductList.length; iii++) {
                        for(let jjj=0; jjj<this.inSalInfo.userProductList[iii].payProductChannelList.length; jjj++) {
                            for(let kkk=0; kkk<this.inSalInfo.userProductList[iii].payProductChannelList[jjj].userRateList.length; kkk++) {
                                let userRate = this.inSalInfo.userProductList[iii].payProductChannelList[jjj].userRateList[kkk];
                                let gMiniRate = this.$root.g_data_mini_rate[userRate.payChannelCode+'-'+userRate.payWayCode+'-'+userRate.payModeCode+'-'+userRate.rateType];
                                // 需要判断gMiniRate是否为null,可能存在一种情况？给商户设置的某条费率信息，在代理商的费率信息里找不到。。。 应该不会。代理商不会删除，可能新增。增量的话，代理商永远包含商户费率信息。
                                // 用费率4要素，去代理商成本费率匹配到最低费率。存在新的最低费率档案里。
                                // 因为最低费率档案，是用ID做索引的，所以新增 和 修改 是有区别的。新增的ID是固定的取成本费率的ID。修改的，每个商户的费率ID都不用，所以需要重组一次最低费率档案。
                                this.arch_miniRate.add(userRate.id, gMiniRate.rate, gMiniRate.fixRate, gMiniRate.feeLowest, gMiniRate.feeHighest,
                                    userRate.payChannelCode, userRate.payWayCode, userRate.payModeCode, userRate.rateType);
                            }
                        }
                    }

                    this.salInfoForm = this.inSalInfo;
                    this.initFormBef();

                    if (this.inOptType==='VIEW') {
                        this.title = '查看客户经理';
                        this.initUserProdRate()
                    }

                    break;
                default:
                    return;
            }

            this.showDlg = true;

        },
        computed: {
            getMyTermRate() {
                return this.myTermRate;
            }
        },
        methods: {
            ysfRateTemplateChanged() {
                // console.log(this.ysfTermRateArray)
            },
            //////////////////////////////////////////////////////////////////////
            // 主选项卡 点击
            //////////////////////////////////////////////////////////////////////
            handleMainTabClick(tab, event) {
                switch (this.activeTabName) {
                    case "tab1":
                        break;
                    case "tab2":
                        this.handleTab2();
                        break;
                }
            },
            //////////////////////////////////////////////////////////////////////
            // 获取当前用户基础产品扣率信息
            //////////////////////////////////////////////////////////////////////
            handleTab2() {
                console.log("this.inOptType", this.inOptType)
                if(this.inOptType==='INS' && this.salInfoForm.userProductList.length===0) { // 新增 - 深度拷贝 产品费率信息，初始化状态未选中
                    this.salInfoForm.userProductList = deepClone(this.arch_userBaseProductRateInfo);
                    this.salInfoForm.userProductList.forEach( item => { item.status = 0; });
                }
                else if(this.inOptType==='UPD') {
                    // 遍历当前商户产品列表，状态1选中，状态0取消选中。
                    this.salInfoForm.userProductList.forEach( item => {
                        if(item.status===1) {
                            this.$refs.prodTable.toggleRowSelection(item,true); // 程序勾选 不会触发@select和@select-all (会触发@selection-change)
                        }
                        else {
                            this.$refs.prodTable.toggleRowSelection(item,false); // 主动勾选 不会触发@select和@select-all (会触发@selection-change)
                        }
                    });
                }
            },
            //////////////////////////////////////////////////////////////////////
            // 获取所有选中的产品代码数组
            //////////////////////////////////////////////////////////////////////
            getSelectRowProductCodeArr() {
                // 获取 - 选中的产品信息
                let selectRow = this.$refs.prodTable.selection;
                let selectRowProductCodeArr = [];
                selectRow.forEach( item => { selectRowProductCodeArr.push(item.payProduct.productCode); });
                return selectRowProductCodeArr;
            },
            //////////////////////////////////////////////////////////////////////
            // 用传入对象 额外初始化一些 当前表单信息
            // 初始化 表单参数 到 特殊组件绑定参数 （展示渲染）
            //////////////////////////////////////////////////////////////////////
            initFormBef() {
            },
            //////////////////////////////////////////////////////////////////////
            // 用当前表单信息 额外初始化一些 传入对象
            // 初始化 特殊组件绑定参数 到 表单参数 （提交后台）
            //////////////////////////////////////////////////////////////////////
            initFormAft() {
                // 补充 - 提交表单的产品信息
                let selectRowProductCodeArr = this.getSelectRowProductCodeArr();
                if(selectRowProductCodeArr.length===0) {
                    this.$message.error("请选择支付产品!");
                    return false;
                }
                else { // 遍历产品列表，根据选中行产品代码数组，更新状态
                    this.salInfoForm.userProductList.forEach( item => { item.status = selectRowProductCodeArr.indexOf(item.payProduct.productCode)===-1?0:1; });
                }

                return true;
            },
            //////////////////////////////////////////////////////////////////////
            // 确认提交
            //////////////////////////////////////////////////////////////////////
            handleMainDlgOkClick() {
                if (this.inOptType==='VIEW') {
                    this.showDlg = false;
                    return;
                }
                if(!this.initFormAft()) // 提交准备
                    return;
                this.$refs['salInfoForm'].validate(valid => {
                    if (valid) {
                        switch (this.inOptType) {
                            case 'UPD':
                                this.updateSalInfo();
                                break;
                            case 'INS':
                                this.insertSalInfo();
                                break;
                            default:
                                this.$message.error("未知提交操作!");
                                break;
                        }
                    }
                });
            },
            //////////////////////////////////////////////////////////////////////
            // 提交数据库插入表单代理商信息
            //////////////////////////////////////////////////////////////////////
            insertSalInfo() {
                this.postRequest("/sal/addSal", this.salInfoForm).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    }
                })
            },
            //////////////////////////////////////////////////////////////////////
            // 提交数据库更新表单代理商信息
            //////////////////////////////////////////////////////////////////////
            updateSalInfo() {
                this.putRequest("/sal/updateSal", this.salInfoForm).then(resp => {
                    if (resp) {
                        this.showDlg = false;
                        this.emitToParent();
                    }
                })
            },
            emitToParent() {
                this.$emit('update:outDlgClosed', true);
            },
            async initUserProdRate() {
                this.isEditTermRate = false
                if (this.loading) return
                // 我的 用户基础产品费率档案
                this.myTermRate = [];
                this.loading = true;
                let resp1 = await this.getRequest(URL_DATA_USER_BASE_PRORATE) ////// 1.我的
                this.loading = false;
                if (resp1) {
                    resp1.data.forEach(item => {
                        if (item.templateRateList) { // 我的终端费率模板
                            this.myTermRate = deepClone(item.templateRateList)
                        }
                    })
                }
                // 传入业务员的 用户基础产品费率档案
                this.ysfTermRateArray = []; // 已勾选的终端费率模板
                this.arch_userBaseProductRateInfo = [];
                this.loading = true;
                let resp2 = await this.getRequest(URL_DATA_USER_BASE_PRORATE_BY_USER+'?userId=' + this.inSalInfo.id + '&userType=5') ////// 5 业务员
                this.loading = false;
                if (resp2) {
                    resp2.data.forEach(item => {
                        if(item.status===1) this.arch_userBaseProductRateInfo.push(item); // 传入服务商的结算费率
                        if (item.templateRateList) { // 传入服务商的终端费率模板
                            item.templateRateList.forEach(item2 => {
                                let ret = this.myTermRate.filter(e => e.rate === item2.rate && e.userType === item2.userType)
                                if (ret.length>0) {
                                    this.ysfTermRateArray.push(item2.rate)
                                }
                            })
                        }
                    })
                }
            },
            async onEditOrSaveTermRate() {
                if (this.isEditTermRate) {
                    this.loading = true
                    let resp = await this.postRequest("/agent/updateTermTemplateRate", {
                        userId: this.inSalInfo.id,
                        userType: 4, // 服务商的 终端 模板费率
                        ysfTermRateArray: this.ysfTermRateArray
                    })
                    this.loading = false
                    if (resp) {
                        this.isEditTermRate = !this.isEditTermRate
                    }
                } else {
                    this.isEditTermRate = !this.isEditTermRate
                }
            }
        }
    }
</script>

<style scoped>

</style>
